import * as yup from 'yup';
import { API as yachts } from '../../yachts/api';
import {
  AreaOptions,
  StatusLogbookDeliveries,
  PickupStatusOptions,
  DefaultStatus,
  DefaultAreas,
  DefaultAreasCaribbean
} from './Data.conf';
import dayjs from 'dayjs';
import { API as users_nautica } from '../../users_nautica/api';
import utc from 'dayjs/plugin/utc';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { API as provenanceList } from '../../provenenceLists/api';

dayjs.extend(utc);
dayjs.extend(isSameOrAfter);

const DefaultFilterConf = {
  schema: yup.object({
    id_yacht: yup.array().nullable(),
    start_date: yup
      .mixed()
      .nullable()
      .transform((value) =>
        value && dayjs(value).isValid()
          ? dayjs(value).format('YYYY-MM-DDTHH:mm:ss')
          : null
      )
      .test('is-valid', 'Invalid date', function (value) {
        if (value) return !!dayjs(value).isValid();
        return true;
      }),
    end_date: yup
      .mixed()
      .nullable()
      .transform((value) =>
        value && dayjs(value).isValid()
          ? dayjs(value).format('YYYY-MM-DDTHH:mm:ss')
          : null
      )
      .test(
        'end-after-start',
        "End date can't be before Start date",
        function (value) {
          const { start_date } = this.parent;

          if (!value || !start_date) return true;
          return dayjs(value).isSameOrAfter(dayjs(start_date));
        }
      )
      .test('is-valid', 'Invalid date', function (value) {
        if (value) return !!dayjs(value).isValid();
        return true;
      }),
    area: yup.array().nullable(),
    provenance: yup.array().nullable(),
  }),
  initialState: {
    value: {
      id_yacht: null,
      status_logbook: DefaultStatus,
      pickup_status: null,
      start_date: dayjs.utc().format('YYYY-MM-DD').toString(),
      end_date: dayjs.utc().endOf('year').format('YYYY-MM-DD').toString(),
      area: DefaultAreas,
      id_driver_in_charge: [],
      provenance: null,
    },
  },
  fields: [
    {
      id: 'id_yacht',
      name: 'id_yacht',
      type: 'async_autocomplete_multiple',
      label: 'Yacht',
      api: yachts.selectWithAttendances,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    }, {
      id: 'pickup_status',
      name: 'pickup_status',
      type: 'autocomplete_multiple',
      label: 'Pickup status',
      options: PickupStatusOptions,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'status_logbook',
      name: 'status_logbook',
      type: 'autocomplete_multiple',
      label: 'Delivery status',
      options: StatusLogbookDeliveries,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'start_date',
      name: 'start_date',
      type: 'date',
      label: 'Start Date',
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'end_date',
      name: 'end_date',
      type: 'date',
      label: 'End Date',
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'area',
      name: 'area',
      type: 'autocomplete_multiple',
      label: 'Area',
      options: AreaOptions,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'id_driver_in_charge',
      name: 'id_driver_in_charge',
      type: 'async_autocomplete_multiple',
      label: 'Driver in charge',
      api: users_nautica.drivers,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'provenance',
      name: 'provenance',
      type: 'async_autocomplete_multiple',
      label: 'Provenance',
      api: provenanceList.provenences,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
  ],
  query: {
    keys: [
      {
        key: 'id_yacht.id',
        value: 'id_yacht.id',
        operator: '$eq',
      },
      {
        key: 'pickup_status',
        value: 'pickup_status.label',
        operator: '$eq',
      },
      {
        key: 'status_logbook',
        value: 'status_logbook.label',
        operator: '$eq',
      },
      {
        key: 'collection_delivery_date',
        value: 'start_date',
        operator: '$gte',
      },
      {
        key: 'collection_delivery_date',
        value: 'end_date',
        operator: '$lte',
      },
      {
        key: 'id_location.area',
        value: 'area.id',
        operator: '$eq',
      },
      {
        key: 'id_driver_in_charge.id',
        value: 'id_driver_in_charge.id',
        operator: '$eq',
      },
      {
        key: 'id_yacht.id_attendance.id_provenence_list.provenence.id',
        value: 'provenance.id',
        operator: '$eq',
      },
    ],
  },
};

const CaribbeanFilterConf = {
  schema: DefaultFilterConf.schema,
  initialState: {
    value: {
      ...DefaultFilterConf.initialState.value,
      area: DefaultAreasCaribbean,
    },
  },
  fields: DefaultFilterConf.fields,
  query: DefaultFilterConf.query,
};

export const FilterConf = {
  DEFAULT: DefaultFilterConf,
  CARAIBI: CaribbeanFilterConf,
};